import { EdgeTheme, FlowTheme, ThemeSettings } from '@/types/theme';
import { createContext } from 'react';

type ThemeContextType = ThemeSettings & {
  gridRatio: number;
  setGridRatio: (ratio: number) => void;
  nodePadding: number;
  setNodePadding: (padding: number) => void;
  toggleMode: () => void;
  toggleFlowTheme: (flowTheme: FlowTheme) => void;
  toggleEdgeTheme: (edgeTheme: EdgeTheme) => void;
};

export const ThemeModeContext = createContext<ThemeContextType>({
  gridRatio: 15,
  setGridRatio: () => {},
  nodePadding: 15,
  setNodePadding: () => {},
  mode: 'dark',
  toggleMode: () => console.warn('No Theme Provider'),
  flowTheme: 'normal',
  toggleFlowTheme: () => console.warn('No Theme Provider'),
  edgeTheme: 'smart',
  toggleEdgeTheme: () => console.warn('No Theme Provider')
});
